export const getters = {
    systemImporters: state => state.importers,
    Importer: state => state.systemImporter
}
export default getters


// WEBPACK FOOTER //
// ./src/vuex/modules/importers/getters.js